import { DataGrid, Spinner } from '@cimplico/components';
import { FolderIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';
import { useFYICabinets } from '../../../../../../queries/use-fyi-cabinets';
import { Cabinet } from '../../../../../../types/fyi-docs';

type FYICabinetsTableProps = {
    onSelect: (cabinet: Cabinet) => void;
};

function FYICabinetsTable({ onSelect }: FYICabinetsTableProps): JSX.Element {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const fyiCabinetQuery = useFYICabinets({ page, limit });

    if (fyiCabinetQuery.isLoading) {
        return (
            <div className="flex items-center justify-center flex-1">
                <Spinner />
            </div>
        );
    }

    const cabinets = fyiCabinetQuery.data?.cabinets ?? [];
    const totalItems = fyiCabinetQuery.data?.totalItems ?? 0;

    return (
        <div className="flex-1">
            <DataGrid
                columns={[{ width: '20px' }, { header: 'Cabinet' }]}
                rowSizes={[25, 50, 100]}
                totalRows={totalItems}
                onPageChange={setPage}
                onRowSizeChange={setLimit}
                isLoading={fyiCabinetQuery.isFetching}
                limitDirection="top"
                stickyHeader
            >
                {cabinets.map((cabinet) => {
                    return (
                        <DataGrid.Row id={cabinet.id.toString()} key={cabinet.id} disabled>
                            <FolderIcon className="text-gray-700 h-5 w-5 shrink-0" />
                            <p
                                className="text-left text-sm font-medium cursor-pointer text-indigo-600 py-1"
                                onClick={(): void => onSelect(cabinet)}
                            >
                                {cabinet.name}
                            </p>
                        </DataGrid.Row>
                    );
                })}
            </DataGrid>
        </div>
    );
}
export default FYICabinetsTable;
